.shell {
  position: relative;
}

.overlay {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: grid;
  place-items: center;
  background: rgba(37, 99, 235, 0.12);
  border: 3px dashed #2563eb;
  color: #1e40af;
  font-size: 1.25rem;
  font-weight: 700;
  pointer-events: none;
}

.root {
  display: grid;
  gap: 0.35rem;
  padding: 2rem;
  border: 2px dashed #93c5fd;
  border-radius: 14px;
  background: var(--mantine-color-body, #fff);
  cursor: pointer;
  margin-bottom: 1rem;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.upload {
  padding: 1.25rem 1.5rem;
  justify-items: center;
  text-align: center;
  gap: 0.5rem;
  max-width: 36rem;
}

.large {
  min-height: 220px;
  place-content: start;
}

.active {
  border-color: #2563eb;
  background: #eff6ff;
}

.warning {
  color: #92400e;
}
